import {Injectable, Inject, EventEmitter} from "@angular/core";
import {AuthenticationService} from "../../api/services/authentication.service";
import {AuthWellKnownEndpoints, OidcSecurityService, OpenIDImplicitFlowConfiguration} from "angular-auth-oidc-client";
import {Observable, Subscription} from "rxjs";
import {RmsUserManagementService} from "./rms-user-management.service";
import {filter, map, take, tap} from "rxjs/internal/operators";
import {JsonWepAuthResponse} from "../../api/models/json-wep-auth-response";

@Injectable()
export class AuthApiService {
  isAuthorizedSubscription: Subscription;
  isAuthorized: boolean = false;
  authFinished: EventEmitter<any> = new EventEmitter<any>();
  showLocationSelect: EventEmitter<any> = new EventEmitter<any>();
  resetPatientSearch: EventEmitter<any> = new EventEmitter<any>();
  showPatientPopup: boolean = true;

  constructor(public oidcSecurityService: OidcSecurityService,
              private authenticateApi: AuthenticationService,
       private userManagementService: RmsUserManagementService,
       @Inject('BASE_URL') baseUrl: string,
       @Inject('IDENTITY_URL') identityUrl: string ){
  }
  initiateLoginFlow(){
    this.oidcSecurityService.onAuthorizationResult.subscribe((res)=>{
    })
  }
  login() {
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.clearToken();

    this.oidcSecurityService.logoff();
  }

  hasAuthenticated() :boolean{

    return (((window.sessionStorage.getItem("_isAuthorized_ndms")  && this.getToken()) || false ) ) as boolean;
  }
  ngOnDestroy(): void {
    if(this.isAuthorizedSubscription)
      this.isAuthorizedSubscription.unsubscribe();
    //if(this.oidcSecurityService.onModuleSetup)
      //this.oidcSecurityService.onModuleSetup.unsubscribe();
  }

  getServerToken(){
    let authResult =window.sessionStorage.getItem("authorizationResult_ndms");
    return JSON.parse(authResult || "{}").id_token || "";
  }
  getUsername(): string {
    return JSON.parse(window.sessionStorage.getItem("userData_ndms") || "{}").name;
  }
  getToken(): string | null{
    if(!window.sessionStorage.getItem("rms_token")){
      return null;
    }
    return "Bearer " + window.sessionStorage.getItem("rms_token");
  }

  setToken(token:string){
    window.sessionStorage.setItem("rms_token",token);
  }
  getRaw(){
    return window.sessionStorage.getItem("rms_token")
  }
  clearToken(){
    window.sessionStorage.removeItem("rms_token");
  }

  authenticate(){
    if(this.getServerToken()){
      return this.authenticateApi.RequestToken({stsJwt:this.getServerToken(),username:this.getUsername()}).pipe(map((res)=>{
        this.setToken(res.model.jwt);
        return res;
      }));
    }else{
      this.login();
    }
  }
  requestToken(){
    return this.authenticateApi.RequestToken({stsJwt:this.getServerToken(),username:this.getUsername()}).pipe(map((res)=>{
      this.setToken(res.model.jwt);
      return res;
    }));
  }
  saveAccessJustification(accountInfo) {
    return this.authenticateApi.SendNewAccountNotification(accountInfo).pipe(map((res)=>{
      return res;
    }));
  }

  setRedirectUrl(url: string) {
    window.sessionStorage.setItem("redirect_url",url);
  }
}
